<div mat-dialog-title>
  <h2>{{ 'dialog.authorization.title' | translate }}</h2>
</div>

<form
  fxLayout="column"
  fxLayoutGap="10px"
  [formGroup]="authForm"
>
  <mat-dialog-content class="p-0">
    <mat-tab-group #tabGroup>
      <mat-tab [label]="'patient-details.authorization-card.tabs.details' | translate">
        <div class="p-4">
          <mmx-auth-details-form
            formControlName="details"
            [includeUnits]="includeUnits"
            [outdated]="outdated"
            [ignoredOutdatedConflicts]="ignoredOutdatedConflicts"
            [outdatedWarnings]="outdatedWarnings"
            [procedureCodes]="procedureCodes$ | async"
            [diagnosisCodes]="diagnosisCodes$ | async"
            [timezone]="data.timezone"
            [nextPullAt]="data.authorization?.nextPullAt"
            (ignoreOutdatedConflicts)="ignoreOutdatedConflicts()"
          ></mmx-auth-details-form>
        </div>
      </mat-tab>

      <mat-tab
        [label]="'patient-details.authorization-card.tabs.clinical-information' | translate"
        [disabled]="!data.authorization?.id"
      >
        <div class="p-4">
          <mmx-auth-clinical-information
            [questions]="questions$ | async"
            [availablePortals]="availablePortals"
            formControlName="clinicalInformation"
            [attachmentsLoading]="attachmentsLoading$ | async"
            [attachments]="attachments$ | async"
            (pendingAttachments)="onPendingAttachments($event)"
            (newAttachmentsAdded)="onNewAttachmentsAdded()"
          ></mmx-auth-clinical-information>
        </div>
      </mat-tab>

      <mat-tab
        *ngIf="data.authorization?.id && isAuthSubmissionSupported"
        [label]="'patient-details.authorization-card.tabs.submit' | translate"
      >
        <div
          *ngIf="insuranceProviderConfigurationService.configuration$ | async as configuration"
          fxLayout="column"
          class="px-4"
        >
          <form [formGroup]="submissionForm">
            <app-prior-authorization-form
              *ngIf="configuration"
              formControlName="priorAuthorization"
              [configuration]="configuration"
              [data]="formData"
            ></app-prior-authorization-form>
          </form>

          <div class="loading-form" *ngIf="insuranceProviderConfigurationService.isLoading$ | async">
            {{ 'common.loading' | translate }}
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button type="button" mat-dialog-close>
      {{ 'common.cancel' | translate }}
    </button>
    <span fxFlex></span>
    <button
      *ngIf="tabGroup.selectedIndex !== 2; else submitToPayerButton"
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="saving$ | async"
      (click)="onSubmit()"
    >
      {{ 'common.save' | translate }}
    </button>

    <ng-template #submitToPayerButton>
      <button
        mat-flat-button
        type="button"
        color="primary"
        [disabled]="submitToPayerDisabled$ | async"
        (click)="onSubmitToPayer()"
      >
        {{ 'patient-details.authorization-card.actions.submit-to-payer' | translate }}
      </button>
    </ng-template>
  </mat-dialog-actions>
</form>
